import React from 'react';

interface ScoreGaugeProps {
  score: number;
}

const ScoreGauge: React.FC<ScoreGaugeProps> = ({ score }) => {
  // Calculate circumference for SVG stroke-dasharray
  const radius = 50;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (score / 100) * circumference;
  
  // Color based on score
  let colorClass = "text-red-500";
  let label = "Técnico / Frío";
  if (score > 40) {
    colorClass = "text-yellow-500";
    label = "Neutro";
  }
  if (score > 75) {
    colorClass = "text-emerald-500";
    label = "Humano / Claro";
  }

  return (
    <div className="flex flex-col items-center justify-center p-6 bg-white rounded-2xl shadow-sm border border-slate-100">
      <h3 className="text-slate-400 text-xs font-bold uppercase tracking-widest mb-4">EMPATIÓMETRO</h3>
      <div className="relative w-40 h-40">
        {/* Background Circle */}
        <svg className="w-full h-full -rotate-90 transform" viewBox="0 0 120 120">
          <circle
            cx="60"
            cy="60"
            r="50"
            fill="none"
            stroke="#e2e8f0"
            strokeWidth="12"
          />
          {/* Progress Circle */}
          <circle
            cx="60"
            cy="60"
            r="50"
            fill="none"
            stroke="currentColor"
            strokeWidth="12"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
            className={`transition-all duration-1000 ease-out ${colorClass}`}
          />
        </svg>
        <div className="absolute top-0 left-0 w-full h-full flex flex-col items-center justify-center">
          <span className={`text-4xl font-bold ${colorClass}`}>
            {score}
          </span>
        </div>
      </div>
      <div className="mt-2 text-center">
        <p className={`text-sm font-medium ${colorClass}`}>{label}</p>
      </div>
    </div>
  );
};

export default ScoreGauge;